// Canonical FederateX model catalog — single source of truth.
//
// Before this module existed, the catalog was defined inline in
// scenes/models/index.jsx (10 models) while the Overview hero banner counted
// the raw `models` context array (6), producing a visible "6 models" vs
// "10 models" mismatch on the dashboard. Both surfaces now import from here.
//
// Grouping mirrors the /models page filter tabs:
//   Tabular (4) + Imaging · Classification (3) + Imaging · Segmentation (3) = 10
export const MODEL_CATALOG = {
  tabular: ['mlp', 'tabnet', 'fttransformer', 'logreg'],
  imaging: ['convnext', 'resnet18', 'swintransformer'],
  segmentation: ['unet', 'unetpp', 'fpn'],
};

// Total number of models advertised across the platform.
export const MODEL_COUNT = Object.values(MODEL_CATALOG).reduce(
  (sum, ids) => sum + ids.length,
  0,
);

export default MODEL_CATALOG;
